import * as React from 'react';
import { DataGrid } from '@mui/x-data-grid';
export default function RBMBudgetTable({rows,Month1,Month2,Month3}) {

const columns = [
  { field: "id", headerName: "ID", width: 40, hide: true },
  {
    field: 'rbmname',
    headerName: 'RBM Name',
    width: 150,
    sortable: false,
  },
  {
    field: 'rbmcode',
    headerName: 'RBM Code',
    width: 150,
    sortable: false,
    hide: true 
  },
  {
    field: 'prodcode',
    headerName: 'Prod code',
    width: 150,
    sortable: false,
  },
  {
    field: 'proddesc',
    headerName: 'Product Description',
    width: 220,
    sortable: false,
  },
  {
    field: 'proxycode',
    headerName: 'Proxy code',
    width: 90,
    sortable: false,
  },
  {
    field: 'brand',
    headerName: 'Brand',
    width: 90,
    sortable: false,
  },
  {
    field: 'm1_adjusted_budget_unit',
    headerName:`${Month1} U`,
    width: 150,
    sortable: true,
    align:"center",

  },
  {
    field: 'm1_adjusted_budget_value',
    headerName: `${Month1} V`,
    width: 150,
    sortable: true,
    align:"center",

  },
  {
    field: 'nsp1',
    headerName: `${Month1} NSP`,
    width: 150,
    sortable: true,
    align:"center",

  },
  {
    field: 'm2_adjusted_budget_unit',
    headerName: `${Month2} U`,
    width: 150,
    sortable: true,
    align:"center"
  },
  {
    field: 'm2_adjusted_budget_value',
    headerName:  `${Month2} V`,
    width: 150,
    sortable: true,
    align:"center"
  },
  {
    field: 'nsp2',
    headerName:  `${Month2} NSP`,
    width: 150,
    sortable: true,
    align:"center"
  },
  {
    field: 'm3_adjusted_budget_unit',
    headerName:  `${Month3} U`,
    width: 150,
    sortable: true,
    align:"center"
  },
  {
    field: 'm3_adjusted_budget_value',
    headerName: `${Month3} V`,
    width: 150,
    sortable: true,align:"center"
  },
  {
    field: 'nsp3',
    headerName:`${Month3} NSP`,
    width: 150,
    sortable: true,
    align:"center"
  },
  
  
];


  return (
    <div style={{ height: 480, width: '100%' }}>
      <DataGrid
        rows={rows}
        Month1={Month1}
        Month2={Month2} 
        Month3={Month3}
        columns={columns}
        pageSize={10}
        rowsPerPageOptions={[10]}
        density='compact'
      />
    </div>
  );
}
